<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.installationjobproduced.header' | translate }}</span>
        </h2>
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.installationjobproduced.job-name' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <input type="text" name="jobName" formControlName="jobName" class="ir-form-set" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.installationjobproduced.sheet-size' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <input type="text" name="sheetSize" formControlName="sheetSize" class="ir-form-set" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.installationjobproduced.prod-speed' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <input type="text" name="productionSpeed" formControlName="productionSpeed" class="ir-form-set" />
            </td>
          </tr>
        </table>
      </div>
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="labelValues"
        *ngFor="let item of formlabelValues.controls; let i = index"
      >
        <table class="ir-modal-table">
          <tr>
            <td></td>
            <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
              <i class="material-icons" (click)="openLabelValuesDeleteConfirm(i)">remove_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationjobproduced.label' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%" [formGroupName]="i">
              <div class="ir-form-group">
                <input type="hidden" class="ir-form-set" formControlName="label" />
                <div
                  class="ir-line ir-select th-select"
                  (click)="openLabelValuesSelector(item.controls.label.value, i)"
                >
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      item.controls.label.value && item.controls.label.value >= 0
                        ? (item.controls.label.value | joblabel)
                        : ('plugins.installationjobproduced.select-label' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationjobproduced.value' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%" [formGroupName]="i">
              <div class="ir-form-group">
                <input type="text" class="ir-form-set" formControlName="value" />
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
        <h2 style="margin-top: 25px">
          <span>{{ 'plugins.installationjobproduced.comment' | translate }}</span>
        </h2>
        <div class="ir-form-group">
          <angular-editor
            id="commentEditor"
            name="comment"
            class="ir-form-set angular-editor"
            formControlName="comment"
            [config]="config"
          ></angular-editor>
        </div>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>
<modal (modalOutput)="selectLabelValuesMenu($event)" (modalClosed)="onClose($event)" #labelValuesModal></modal>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #labelValueDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>record</strong>?'"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
